// Journal de bord (R-JRN-01 à R-JRN-05).
import { useMemo, useState } from 'react';
import { useMagasin, magasin } from '../donnees/magasin';
import type { TypeEntreeJournal } from '@partage/types';

const TYPES: Record<TypeEntreeJournal, string> = { cloture: 'Clôture', libre: 'Libre', revue_sprint: 'Revue de sprint', retro_sprint: 'Rétro de sprint', bilan_saison: 'Bilan de saison', note_mentor: 'Note du mentor' };

export function Journal() {
  const { etat } = useMagasin();
  const [filtre, setFiltre] = useState<'tous' | TypeEntreeJournal>('tous');
  const [recherche, setRecherche] = useState('');
  const [texte, setTexte] = useState('');
  const [type, setType] = useState<'libre' | 'revue_sprint' | 'retro_sprint' | 'bilan_saison'>('libre');
  const [edition, setEdition] = useState<{ id: string; texte: string }>();

  const entrees = useMemo(() => [...etat.journal].filter((e) => !e.archivee && (filtre === 'tous' || e.type === filtre) && (!recherche || e.texte.toLowerCase().includes(recherche.toLowerCase()))).sort((a, b) => b.le.localeCompare(a.le)), [etat.journal, filtre, recherche]);

  async function ajouter() {
    if (!texte.trim()) return;
    await magasin.emettre('entree_journal_ajoutee', { entree: crypto.randomUUID(), type, texte: texte.trim() });
    setTexte('');
  }

  return (
    <>
      <h2>Journal de bord</h2>
      <div className="carte">
        <div className="champ"><label htmlFor="nouvelle">Nouvelle entrée</label><textarea id="nouvelle" rows={3} value={texte} onChange={(e) => setTexte(e.target.value)} placeholder="Une idée, une difficulté, une victoire…" /></div>
        <div className="ligne">
          <select value={type} onChange={(e) => setType(e.target.value as typeof type)} style={{ width: 'auto' }}>
            <option value="libre">Libre</option><option value="revue_sprint">Revue de sprint</option><option value="retro_sprint">Rétro de sprint</option><option value="bilan_saison">Bilan de saison</option>
          </select>
          <button className="principal" onClick={() => void ajouter()}>Ajouter</button>
        </div>
      </div>
      <div className="ligne" style={{ margin: '1em 0' }}>
        <select value={filtre} onChange={(e) => setFiltre(e.target.value as typeof filtre)} style={{ width: 'auto' }}>
          <option value="tous">Tous les types</option>
          {Object.entries(TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <input placeholder="Rechercher…" value={recherche} onChange={(e) => setRecherche(e.target.value)} style={{ maxWidth: 280 }} />
        <span className="doux petit-texte">{entrees.length} entrée(s)</span>
      </div>
      <div className="carte">
        {entrees.length === 0 ? <p className="vide">Rien ici pour l’instant.</p> : entrees.map((e) => {
          const modifiable = e.type !== 'note_mentor' && Date.now() - new Date(e.le).getTime() < 24 * 3600 * 1000;
          return (
            <div className={`journal-entree ${e.type}`} key={e.id}>
              <div className="meta">
                <span>{new Date(e.le).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' })}</span>
                <span className="badge">{TYPES[e.type]}{e.sous_type ? ` · ${e.sous_type}` : ''}</span>
                {e.session ? <span className="badge accent">{e.session}</span> : null}
                {e.energie ? <span>énergie {e.energie}/5</span> : null}
                {e.modifiee_le ? <span>(modifiée)</span> : null}
              </div>
              {edition?.id === e.id ? (
                <div>
                  <textarea rows={3} value={edition.texte} onChange={(ev) => setEdition({ id: e.id, texte: ev.target.value })} />
                  <div className="ligne" style={{ marginTop: '0.4em' }}>
                    <button className="principal petit" onClick={async () => { await magasin.emettre('entree_journal_modifiee', { entree: e.id, texte: edition.texte }); setEdition(undefined); }}>Enregistrer</button>
                    <button className="petit" onClick={() => setEdition(undefined)}>Annuler</button>
                  </div>
                </div>
              ) : <div className="texte">{e.texte}</div>}
              <div className="ligne" style={{ marginTop: '0.3em' }}>
                {modifiable && edition?.id !== e.id ? <button className="discret petit" onClick={() => setEdition({ id: e.id, texte: e.texte })}>Modifier (24 h)</button> : null}
                {e.type !== 'note_mentor' ? <button className="discret petit" onClick={() => { if (window.confirm('Archiver cette entrée ? (elle reste dans l’historique, mais n’apparaît plus)')) void magasin.emettre('entree_journal_archivee', { entree: e.id }); }}>Archiver</button> : null}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
